import * as React from 'react';
import { Action } from 'redux';
import { ErrorViewModel } from 'stageclip-common';

import { InternalActionTypes } from '../constants/actionTypes';
import { FormId } from '../constants/formId';

export interface RequestLoadingErrorAction extends Action {
  type: InternalActionTypes.RequestLoadingError;
  error: ErrorViewModel;
  component: React.Component;
}

export interface RequestSuccessfulAction extends Action {
  type: InternalActionTypes.RequestSuccessful;
  component: React.Component;
}

export interface ClearRequestErrorsAction extends Action {
  type: InternalActionTypes.ClearRequestErrors;
  component: React.Component;
}

export interface ClearSyncErrorsAction extends Action {
  type: InternalActionTypes.ClearSyncErrors;
  formId: FormId;
}

export function createRequestLoadingErrorAction(
  component: React.Component,
  error: ErrorViewModel,
): RequestLoadingErrorAction {
  return {
    component,
    error,
    type: InternalActionTypes.RequestLoadingError,
  };
}

export function createRequestSuccessfulAction(component: React.Component): RequestSuccessfulAction {
  return {
    component,
    type: InternalActionTypes.RequestSuccessful,
  };
}

export function createClearRequestErrorsAction(component: React.Component): ClearRequestErrorsAction {
  return {
    component,
    type: InternalActionTypes.ClearRequestErrors,
  };
}

export function createClearSyncErrorsAction(formId: FormId): ClearSyncErrorsAction {
  return {
    formId,
    type: InternalActionTypes.ClearSyncErrors,
  };
}
